@if (isAssetCard() && assetTrustState() !== 'none') {
  <span class="dot"></span>
}
@switch (assetTrustState()) {
  @case ('governance_only') {
    <div class="container governance">
      <svg
        width="11"
        height="11"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        <polyline points="9 12 11 14 15 10" />
      </svg>
      <span>Governance</span>
    </div>
  }
  @case ('rai_only') {
    <div class="container rai">
      <svg
        width="11"
        height="11"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        <polyline points="9 12 11 14 15 10" />
      </svg>
      <span>Responsible AI</span>
    </div>
  }
  @case ('governance_and_rai') {
    <div
      class="container multiple"
      [matMenuTriggerFor]="tooltip"
      #menuTrigger="matMenuTrigger"
      (mouseenter)="menuTrigger.openMenu()"
      (mouseleave)="menuTrigger.closeMenu()"
    >
      <svg
        width="11"
        height="11"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        <polyline points="9 12 11 14 15 10" />
      </svg>
      <span>2 Verifications</span>
    </div>
    <mat-menu
      #tooltip="matMenu"
      class="custom-tooltip-menu"
      [hasBackdrop]="false"
      yPosition="above"
    >
      <div class="container governance">
        <svg
          width="11"
          height="11"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          <polyline points="9 12 11 14 15 10" />
        </svg>
        <span>Governance</span>
      </div>
      <div class="container rai">
        <svg
          width="11"
          height="11"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          <polyline points="9 12 11 14 15 10" />
        </svg>
        <span>Responsible AI</span>
      </div>
    </mat-menu>
  }
  @case ('verification_in_progress') {
    <div class="container verification">
      <ng-icon name="tablerClock" size="12px" />
      <span>Verification in Progress</span>
    </div>
  }
  @case ('none') {
    <!-- Nothing to show -->
  }
  @default {
    <!-- error case -->
    <div class="container error">
      <ng-icon name="tablerShieldQuestion" size="12px" />
      <span>Unknown</span>
    </div>
  }
}
